/**
 * DisplayItem > Meta object.
 *
 * @typedef {Object} Meta
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {Integer} timestamp The item creation timestamp.
 * @property {String} network The social network from which the item originates.
 * @property {String} itemClass The type of source the item originates from (eg. social|entry|ugc|promotion|native).
 * @property {String} contentType The type of content (eg. image|video|text).
 * @property {String} tags Arbitrary, csv string of tags associated with the item.
 * @property {String} pinned priority value assigned for item (sticky).
 */
class Meta {
  constructor(timestamp, network, itemClass, contentType, tags, pinned) {
    this.timestamp = timestamp;
    this.network = network;
    this.itemClass = itemClass;
    this.contentType = contentType;
    this.tags = tags;
    this.pinned = pinned;
  }
}

export default Meta;
